module.exports = __webpack_public_path__ + "static/media/Logo Vertical.0f6d6b1d.jpg";